module.exports = __webpack_public_path__ + "static/media/hugeicons_doctor.dbbce373.svg";